import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main className="policy-page delivery">
      <header>
        <p className="eyebrow">Customer care</p>
        <h1>Shipping &amp; delivery</h1>
        <p>
          Delivery options are calculated from the destination entered at
          checkout. A dispatch email is sent when tracking becomes available.
        </p>
      </header>
      <section className="policy-accordions">
        <details open>
          <summary>Order preparation</summary>
          <p>
            In-stock pieces are prepared within 1–2 business days. During
            collection launches or public holidays, preparation may take one
            additional working day.
          </p>
        </details>
        <details>
          <summary>Estimated delivery times</summary>
          <p>
            Current service levels and estimates appear during checkout after a
            destination is entered. Timing begins when the parcel is collected.
          </p>
        </details>
        <details>
          <summary>Rates, duties &amp; taxes</summary>
          <p>
            Standard delivery is {formatPrice(siteConfig.commerce.standardShipping)}
            and becomes complimentary over {formatPrice(siteConfig.commerce.freeShippingThreshold)}.
            Taxes or import charges depend on the destination and are shown or
            explained during checkout where available.
          </p>
        </details>
        <details>
          <summary>Tracking your parcel</summary>
          <p>
            A tracking link is included in the dispatch confirmation. If a parcel
            appears delayed, please contact us with your order number.
          </p>
        </details>
      </section>
      <div className="policy-contact">
        <h2>Need help with a delivery?</h2>
        <p>Email {siteConfig.contact.email} with your order number and destination.</p>
        <Link className="solid-button" to="/contact">Contact client service</Link>
      </div>
    </main>
  );
}

export default Delivery;
